import React from 'react'
import { View, StyleSheet } from 'react-native'
import variables from './_variables.scss'

const headerHeight = parseInt(variables.headerHeight, 10)

const AppMain = ({ style, children }) => (
  <View style={[styles.main, style]}>
    {children}
  </View>
)

const styles = StyleSheet.create({
  main: {
    padding: 8,
    paddingTop: headerHeight + 8,
    minHeight: '100vh',
  },
})

export default AppMain
